import React, { Component } from "react";
import { TableDefault, LabelString, LabelDollarFormatted, LabelDate } from "@loanbossinc/component-library";
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';


const LOAN_LOCKOUT = "LOCKOUT";
const DEFAULT_LENDER_NAME = "Lender Selection Needed";

export class ActiveLoanBodyList extends Component {
    loanTableCols = () => {
        return [
            {
                id: 'loan',
                label: 'LOAN',
                path: 'loan',
                Cell: (value) => value.lienPriority ? (
                    <Tooltip title={value.lienPriority} TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right-start">
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <LabelString style={{ color: "#000", fontWeight: "500" }} value={value.lenderCompanyName} />
                            <LabelString value={value.loanDate} />
                        </div>
                    </Tooltip>
                ) :
                (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <LabelString style={{ color: "#000", fontWeight: "500" }} value={value.lenderCompanyName} />
                        <LabelString value={value.loanDate} />
                    </div>
                )
            },
            {
                id: 'currentPrincipalBalance',
                label: 'LOAN BALANCE',
                path: 'currentPrincipalBalance',
                Cell: (value) => <LabelDollarFormatted value={value} decimals={0} />
            },
            {
                id: 'maturityDate',
                label: 'MATURITY',
                path: 'maturityDate',
                Cell: (value) => ( <LabelDate value={value} />)
            }
        ]
    }

    getLenderCompanyName = (loan) => {
        if (!loan || !loan.lenderCompany || !loan.lenderCompany.name) return DEFAULT_LENDER_NAME;
        const lenderCompanyName = loan.lenderCompany.name;
        return lenderCompanyName.length > 40 ? `${lenderCompanyName.slice(0, 40).trim()}... ` : lenderCompanyName;
    }

    getLoanDate = (loan) => {
        return moment(loan.closingDate).format('YYYY');
    }
    getLienPriority = (loan) => {
        if (!loan || !loan.lienPriority ) return null;        
        return `Lien Priority: ${loan.lienPriority}`.trim();
    }
    getColumnData = () => {
        const { loans } = this.props;
        return loans.reduce((acc, cur) => {
            acc.push({
                id: cur.id,
                prepaymentPenalty: cur.isLockout ? LOAN_LOCKOUT : cur.prepaymentPenalty,
                maturityDate: cur.maturityDate,
                currentPrincipalBalance: cur.currentPrincipalBalance,
                loan: {
                    loanDate: this.getLoanDate(cur),
                    lenderCompanyName: this.getLenderCompanyName(cur),
                    lienPriority: this.getLienPriority(cur)
                }
            })
            return acc;
        }, []);
    }

    render() {
        const { dealId, toLoanDetails } = this.props;
        return (
            <div>
                <TableDefault
                    elevation={0}
                    columns={this.loanTableCols()}
                    items={this.getColumnData()}
                    onRowClick={(loan) => { toLoanDetails(dealId, loan.id) }} />
            </div>
        )
    }
}
